import React, { useState } from "react";
import { callButtonGeneral } from "../../DataApi/generalApis/callButtonGeneral";
import { useSession } from "../../authentications/SessionContext";
import { get_installed } from "../../DataApi/generalApis/get_installed";
import { searchReadGeneral } from "../../DataApi/generalApis/searchReadGeneral";
import useConfirmationModal from "../../Components/ConfirmationModal/useConfirmationModal";
import Modal from "../Kanban/Modal/Modal";

const Translator = ({
  isCreateModalOpen,
  setIsCreateModalOpen,
  productId,
  modelSpecific,
  color,
  fieldName,
  fieldValue,
  setUpdatedData,
  right,
  top,
}) => {
  const { sessionInfo } = useSession();
  const { company_id, context } = sessionInfo;
  context["allowed_company_ids"] = [company_id];
  const fieldModel = modelSpecific || "product.template";
  const {
    setIsDisabled: setDisableModalButton,
    ConfirmationModal,
    setTitle,
    setMetaData,
    setOpenModal: setOpenConfirmationModal,
  } = useConfirmationModal();
  const handleCloseModal = () => {
    setIsCreateModalOpen(false);
  };
  const handleTranslateClick = async () => {
    // console.log("Translate clicked for product ID:", productId, fieldName);
    if (productId) {
      try {
        let callBtnresponse = await callButtonGeneral({
          company_id,
          method: "translate_fields",
          model: "ir.translation",
          args: [fieldModel, productId, fieldName],
          context,
        });
        if (callBtnresponse?.result) {
          let updatedDomain = [
            ...callBtnresponse.result.domain,
            ["name", "=", `${fieldModel},${fieldName}`],
            ["lang", "in", ["ar_001", "en_US"]],
          ];
          // console.log("callBtnresponse", callBtnresponse);
          let get_installed_resp = await get_installed({
            company_id,
            method: "get_installed",
            model: "res.lang",
            args: [],
            context,
          });
          if (get_installed_resp && updatedDomain.length > 0) {
            let languageList = get_installed_resp?.result;
            // console.log(
            //   "get_installed_resp languageList",
            //   get_installed_resp,
            //   languageList
            // );
            let searchReadResp = await searchReadGeneral({
              context,
              company_id,
              fields: ["lang", "src", "value"],
              model: "ir.translation",
              domain: updatedDomain,
            });
            if (searchReadResp?.result) {
              let filteredData = searchReadResp?.result?.records?.filter(
                //remove && rec.lang === "ar_001" for making in generic
                (rec) => rec.src === fieldValue && rec.lang === "ar_001"
              );
              const data = filteredData.map((item) => {
                const matchingLanguage = languageList.find(
                  ([code]) => code === item.lang
                );
                return {
                  ...item,
                  label: matchingLanguage
                    ? matchingLanguage[1]
                    : "Unknown Language",
                  value: item?.value || item?.src,
                };
              });
              // console.log(data, "data");

              setUpdatedData(data);
              setIsCreateModalOpen(true);

              // console.log("filteredData", filteredData);
              // console.log("searchReadResp", searchReadResp);
            }
          }
        }
      } catch (error) {
        return console.log("error in translate call_button api", error);
      }
    }
  };

  return (
    <>
      <a
        className="translateBtn"
        onClick={handleTranslateClick}
        title="Translate"
        style={{
          position: "absolute",
          right: right ? right : "10px",
          top: top ? top : "",
          color: color,
          cursor: "pointer",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-translate"
          viewBox="0 0 16 16"
        >
          <path d="M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286zm1.634-.736L5.5 3.956h-.049l-.679 2.022z" />
          <path d="M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm7.138 9.995q.289.451.63.846c-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6 6 0 0 1-.415-.492 2 2 0 0 1-.94.31" />
        </svg>
      </a>
    </>
  );
};

export default Translator;
